import { useCallback } from "react"
import { getAsksByUser } from '../../sushi/utils'
import { getUserAsksByNFT } from '../../sushi/exchangeNFTs'
import { userBidNFTContract } from '../../userType/userBidNFTContract'

import { useActiveWeb3React } from '../'
import useYam from "../bakery/useYam"
import { MARKETTYPE, MARKETTYPEV1, MARKETMULTITOKEN, MARKETTYPEV3 } from '../../constants/bakery/nft'
import { multiTokenExchangeNftContract } from '../../userType/multiTokenExchangeNftContract'
import { userExchangeNFTContract } from '../../userType/userExchangeNFTContract'

import { userNftAddress } from '../../userType/userNftAddress'
import { userV3NFTContract } from "../../userType/userV3NFTContract"

const useUserAsks = (type?: string, owner?: string) => {
  const { account } = useActiveWeb3React()
  const sushi = useYam()

  let exchangeNFTContract: any
  let isMultiToken:boolean = false

  if(type && MARKETTYPE.hasOwnProperty(type)){
    exchangeNFTContract = userBidNFTContract(sushi, type)
    isMultiToken = false
  }else if(type && MARKETMULTITOKEN.hasOwnProperty(type)){
    exchangeNFTContract = multiTokenExchangeNftContract(sushi, type)
    isMultiToken = true
  } else if (type && MARKETTYPEV1.hasOwnProperty(type)){
    exchangeNFTContract = userExchangeNFTContract(sushi, type)
    isMultiToken = false
  } else if (type && MARKETTYPEV3.hasOwnProperty(type)){
    exchangeNFTContract = userV3NFTContract(sushi, type)
    isMultiToken = true
  }
  
  const userAsks = useCallback(async() => {
    try {
      let userAsks: any[] = []
     
      if(!isMultiToken) {
        if (owner) {
          userAsks = await getAsksByUser(exchangeNFTContract, owner)
        } else {
          userAsks = await getAsksByUser(exchangeNFTContract, account)
        }
      }else {
        if(type && MARKETMULTITOKEN.hasOwnProperty(type) || (type && MARKETTYPEV3.hasOwnProperty(type))){
          let nftAddress = userNftAddress(sushi, type)
          if (owner) {
            let curTokenAsks = await getUserAsksByNFT(exchangeNFTContract, nftAddress, owner)
            userAsks = curTokenAsks.map((d: any) => {
              return [
                d.tokenId,
                d.price
              ]
            })
          } else {
            let curTokenAsks = await getUserAsksByNFT(exchangeNFTContract, nftAddress, account)
            userAsks = curTokenAsks.map((d: any) => {
              return [
                d.tokenId,
                d.price
              ]
            })
          }
        }
      }
      const list = userAsks.map((d: any) => {
        return {
          ...d,
          type: 'ASK'
        }
      })
      return list
    } catch (e) {
      return []
    }
  }, [account, exchangeNFTContract, owner,isMultiToken,sushi,type])
  return userAsks
}

export default useUserAsks